import { Flex, Image, Link } from '@chakra-ui/react';

export default function Footer() {
  return (
    <Flex as={'footer'} w={'full'} zIndex={11} py={3} px={4} mt={6}>
      <Link href={'https://athleteera.app'} target='_blank'>
        <Image src={'/logo_horizontal.png'} alt={'Coach Hub'} height={'24px'} fit='contain' />
      </Link>
    </Flex>
  );
}
